import { Injectable } from '@angular/core';
import { FuncionarioPorAreaAtuacaoDto } from '../../dtos'
import { CaqRequestService } from '../'
import { map, firstValueFrom } from 'rxjs';
import { environment } from '../../../environments/environment';

interface FuncionariosPorAreaAtuacaoResponse {
  content: FuncionarioPorAreaAtuacaoDto[]
}

@Injectable({
  providedIn: 'root'
})
export class FuncionariosPorAreaAtuacaoService {
  public urlBase = `${environment.apiUrl}/funcionarios/por-area-atuacao`;

  constructor(private caqRequestService: CaqRequestService) {}

  async buscaFuncionariosPorAreaAtuacao(): Promise<FuncionarioPorAreaAtuacaoDto[]> {
    return firstValueFrom(this.caqRequestService
      .get<FuncionariosPorAreaAtuacaoResponse>(this.urlBase)
      .pipe(map((response) => response.content)));
  }
}
